import PageNavBackLayoutCpt from '@/components/page/PageNavBackLayoutCpt';
import AttachmentListCpt from '@/components/attachment/AttachmentListCpt';
export default {
  components: {
    PageNavBackLayoutCpt,
    AttachmentListCpt
  },
  data() {
    return {
      businessId: null,
      attachmentType: null,
      flag: null
    };
  },
  created() {
    this.businessId = this.$route.params.businessId;
    this.attachmentType = this.$route.params.attachmentType;
    this.flag = this.$route.params.flag;
  },
  mounted() {}
};